export const TARGET_ID = "cronofy-date-time-picker";

export const CRONOFY_NOTIFICATION_TYPE = {
  SLOT_SELECTED: "slot_selected",
  ERROR: "error",
};

export const CRONOFY_ERROR_TYPE_KEY = {
  REQUIRED: "errors.required",
};

export const CRONOFY_ISO_FORMAT = "YYYY-MM-DDTHH:mm:00Z";
